/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { rankingManager } from "../../../../api/Api";

export const getAllRankingManager = createAsyncThunk(
  "appRankingManager/getAllRankingManager",
  async (values) => {
    try {
      return rankingManager.getAll(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const appRankingManagerSlice = createSlice({
  name: "appRankingManager",
  initialState: {
    rankingManager: [],
    rankingManagerFetch: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllRankingManager.fulfilled, (state, action) => {
      state.rankingManager = action.payload?.data?.data;
      state.rankingManagerFetch = true;
    });
  },
});

export default appRankingManagerSlice.reducer;
